import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { Creators as CegActions, Types as CegTypes } from 'store/ducks/Ceg';
import api from '../../util/Api';
import * as Sentry from '@sentry/react';

function* getCeg({ payload }) {
  try {
    const { status, data } = yield call(api.get, '/cegs', {
      params: payload,
    });
    if (status === 200) {
      yield put(CegActions.getCegSuccess(data));
    } else {
      Sentry.captureMessage('getCeg failed: status not 200', {
        level: 'error',
        extra: { payload, status, data },
      });
      yield put(CegActions.getCegFail());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(CegActions.getCegFail());
  }
}

function* getListCeg() {
  try {
    const { status, data } = yield call(api.get, '/cegs', { params: { all: 1, without_business: 1 } });
    if (status === 200) {
      yield put(CegActions.getCegListSuccess(data));
    } else {
      Sentry.captureMessage('getListCeg failed: status not 200', {
        level: 'error',
        extra: { status, data },
      });
      yield put(CegActions.getCegListError());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { message: "Dont have payload" } });
    yield put(CegActions.getCegListError());
  }
}

function* createCeg({ payload }) {
  try {
    const { status } = yield call(api.post, '/cegs', payload);
    if (status === 200) {
      yield put(CegActions.createCegSuccess());
    } else {
      Sentry.captureMessage('createCeg failed: status not 200', {
        level: 'error',
        extra: { payload, status },
      });
      yield put(CegActions.createCegFail());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(CegActions.createCegFail());
  }
}

function* getCegWatcher() {
  yield takeLatest(CegTypes.GET_CEG_REQUEST, getCeg);
}

function* getCegListWatcher() {
  yield takeLatest(CegTypes.GET_CEG_LIST, getListCeg);
}

function* getCegCreateWatcher() {
  yield takeLatest(CegTypes.CREATE_CEG_REQUEST, createCeg);
}

export default function* rootSaga() {
  yield all([fork(getCegWatcher), fork(getCegListWatcher), fork(getCegCreateWatcher)]);
}
